<div
  class="modal-footer justify-content-start"
  [ngClass]="{ 'disabled-project': config?.isProjectLocked }"
>
  <button
    type="button"
    class="btn back-btn modelBtn"
    (click)="backRoute()"
    *ngIf="config?.isProductPage"
  >
    <i class="bi bi-arrow-left checkboxLeft-div"></i> Back
  </button>
  <button type="button" class="btn next-btn modelBtn" (click)="change()">
    Next <i class="bi bi-arrow-right checkbox-div"></i>
  </button>
</div>
